import { gql } from '@apollo/client';
import type { TypedDocumentNode } from '@apollo/client';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex/index.tsx';
import { TextureBackground } from '@sorare/core/src/atoms/ui/TextureBackground/index.tsx';
import { Header } from '@sorare/core/src/components/dialog/Header/index.tsx';
import { Dialog } from '@sorare/core/src/components/dialog/index.tsx';

import { ReferralMissionDetails } from '../ReferralMissionDetails/index.tsx';
import type { ReferralMissionDialog_inviteTaskAsReferrer } from './__generated__/index.graphql.ts';

const Root = styled(Vertical).attrs({ gap: 1.5 })`
  position: relative;
  min-height: 100%;
  isolation: isolate;
`;
const StyledTextureBackground = styled(TextureBackground)`
  position: absolute;
  inset: 0;
  z-index: -1;
`;

type Props = {
  open: boolean;
  onClose: () => void;
  task: ReferralMissionDialog_inviteTaskAsReferrer;
};

export const ReferralMissionDialog = ({ open, onClose, task }: Props) => {
  return (
    <Dialog open={open} fullWidth maxWidth="xs" hideHeader>
      <Root>
        <StyledTextureBackground
          background="wave1"
          mode="dark"
          color="var(--c-set-surface-primary)"
        />
        <Header onBack={onClose} />
        <ReferralMissionDetails task={task} />
      </Root>
    </Dialog>
  );
};

ReferralMissionDialog.fragments = {
  inviteTaskAsReferrer: gql`
    fragment ReferralMissionDialog_inviteTaskAsReferrer on InviteTaskAsReferrer {
      id
      ...ReferralMissionDetails_inviteTaskAsReferrer
    }
    ${ReferralMissionDetails.fragments.inviteTaskAsReferrer}
  ` as TypedDocumentNode<ReferralMissionDialog_inviteTaskAsReferrer>,
};
